import { AxiosResponse } from 'axios';
import { FBaseService } from '@kasasa/fbase-components/lib';
import { Report } from './Report';

export class ReportResource extends FBaseService {
  public async getReportInfos(fiId: string, cycleId: number, fileFormatFilter: string): Promise<Report[]> {
    const response: AxiosResponse = await this.apiClient.get(
      `/api/rcx/reporting/${fiId}/reports-list/${cycleId}/${fileFormatFilter}`,
    );
    const rows: Report[] = response.data;
    return rows;
  }

  public async getReportInfosForReportDate(fiId: string, reportDate: string, fileFormatFilter: string): Promise<Report[]> {
    const response: AxiosResponse = await this.apiClient.get(
      `/api/rcx/reporting/${fiId}/reports-list-by-date/${reportDate}/${fileFormatFilter}`,
    );
    const rows: Report[] = response.data;
    return rows;
  }

  public async downloadReport(fiId: string, cycleId: number, fileName: string): Promise<Blob> {
    const response: AxiosResponse = await this.apiClient.get(
      `/api/rcx/reporting/${fiId}/reports/${cycleId}/${fileName}`, { responseType: 'blob' },
    );
    return response.data;
  }

  public async downloadReportForDate(fiId: string, date: string, fileName: string): Promise<Blob> {
    const response: AxiosResponse = await this.apiClient.get(
      `/api/rcx/reporting/${fiId}/reports-by-date/${date}/${fileName}`, { responseType: 'blob' },
    );
    return response.data;
  }
}

export default ReportResource;
